import { dataPaste } from 'dls-icons-data'
import { createIcon } from '../common'

const IconPaste = /*#__PURE__*/createIcon(dataPaste)
export default IconPaste
